"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emojiAwareSplit = void 0;
const emojiAwareSplit = (text) => Intl.Segmenter
    ? [...new Intl.Segmenter().segment(text)].map((data) => data.segment)
    : text;
exports.emojiAwareSplit = emojiAwareSplit;
//# sourceMappingURL=emoji.js.map